import Notice from './components/Notice';

export default Notice;
